import React, {forwardRef, useEffect, useState} from "react";
import Select from "react-select";
import "../styles/InitialFormPage.css";

interface SelectComponentProps {
    name: string;
    label: string;
    options: { value: string; label: string }[];
    value?: string;
    error?: string;
    onChange: (value: string) => void;
    required?: boolean;
    disabled?: boolean;
    emptyText?: string;
}

export const SelectComponent = forwardRef<HTMLDivElement, SelectComponentProps>(
    ({name, label, options, value, error, onChange, required, disabled, emptyText}, ref) => {
        const [hasValue, setHasValue] = useState(false);

        useEffect(() => {
            setHasValue(!!value);
        }, [value]);

        return (
            <div
                className={`floating-select ${hasValue ? "has-value" : ""} ${error ? "has-error" : ""}`}
                ref={ref}
            >
                <Select
                    inputId={name}
                    options={options}
                    value={options.find((opt) => opt.value === value) || null}
                    onChange={(selected) => onChange(selected?.value || "")}
                    placeholder=""
                    classNamePrefix="custom-select"
                    isDisabled={disabled}
                    noOptionsMessage={() => emptyText || "No hay opciones"}
                    menuPlacement="auto"
                />
                <label htmlFor={name}>
                    {label}{required ? <span className="req">*</span> : null}
                </label>
                {error && <span className="error-text">{error}</span>}
            </div>
        );
    }
);
